module.exports = __webpack_public_path__ + "media/images/icons/phone-black-5d724f2993ba5f71b27e15dc0679ea48.svg";